import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { white, greyDark } from "../../styles/variables";

const { spacing } = theme;

export const paper = css`
  z-index: 200;
  .arrow {
    position: absolute;
    font-size: 8px;
    width: 0;
    height: 0;

    &::before {
      content: "";
      margin: auto;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
    }
  }
  &[x-placement*="bottom"] {
    margin-top: ${spacing(1.25)}px;

    .arrow {
      margin-top: -${spacing(1)}px;

      &::before {
        border-width: 0 8px 8px 8px;
        border-color: transparent transparent ${white} transparent;
      }
    }
  }

  &[x-placement*="top"] {
    margin-bottom: ${spacing(1.25)}px;

    .arrow {
      bottom: 0;

      &::before {
        border-width: 8px 8px 0 8px;
        border-color: ${white} transparent transparent transparent;
      }
    }
  }

  &[x-placement*="right"] {
    margin-left: ${spacing(1.25)}px;

    .arrow {
      left: 0;
      margin-left: -${spacing(1)}px;

      &::before {
        border-width: 8px 8px 8px 0;
        border-color: transparent ${white} transparent transparent;
      }
    }
  }

  &[x-placement*="left"] {
    margin-right: ${spacing(1.25)}px;

    .arrow {
      right: 0;

      &::before {
        border-width: 8px 0 8px 8px;
        border-color: transparent transparent transparent ${white};
      }
    }
  }

  &[x-placement="top"],
  &[x-placement="bottom"] {
    .arrow {
      right: 0;
      left: 0;
      margin-right: auto;
      margin-left: auto;
    }
  }

  &[x-placement="left"],
  &[x-placement="right"] {
    .arrow {
      top: 0;
      bottom: 0;
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  &[x-placement="bottom-start"] {
    .arrow {
      /* Workaround: align design;Workaround */
      left: 0 !important;

      &::before {
        border-left-width: 0;
      }
    }

    .MuiBox-root {
      border-top-left-radius: 0;
    }
  }

  &[x-placement="bottom-end"] {
    .arrow {
      /* Workaround: align design;Workaround */
      right: 0 !important;
      margin-right: ${spacing(1)}px;

      &::before {
        border-right-width: 0;
      }
    }

    .MuiBox-root {
      border-top-right-radius: 0;
    }
  }

  &[x-placement="top-start"] {
    .arrow {
      /* Workaround: align design;Workaround */
      left: 0 !important;

      &::before {
        border-left-width: 0;
      }
    }

    .MuiBox-root {
      border-bottom-left-radius: 0;
    }
  }

  &[x-placement="top-end"] {
    .arrow {
      /* Workaround: align design;Workaround */
      right: 0 !important;

      &::before {
        border-right-width: 0;
      }
    }

    .MuiBox-root {
      border-bottom-right-radius: 0;
    }
  }

  &[x-placement="right-start"] {
    .arrow {
      /* Workaround: align design;Workaround */
      top: 0 !important;

      &::before {
        border-top-width: 0;
      }
    }

    .MuiBox-root {
      border-top-left-radius: 0;
    }
  }

  &[x-placement="right-end"] {
    .arrow {
      /* Workaround: align design;Workaround */
      bottom: 0 !important;
      margin-bottom: ${spacing(1)}px;

      &::before {
        border-bottom-width: 0;
      }
    }

    .MuiBox-root {
      border-bottom-left-radius: 0;
    }
  }

  &[x-placement="left-start"] {
    .arrow {
      /* Workaround: align design;Workaround */
      top: 0 !important;

      &::before {
        border-top-width: 0;
      }
    }
    .MuiBox-root {
      border-top-right-radius: 0;
    }
  }

  &[x-placement="left-end"] {
    .arrow {
      /* Workaround: align design;Workaround */
      bottom: 0 !important;
      margin-bottom: ${spacing(1)}px;

      &::before {
        border-bottom-width: 0;
      }
    }

    .MuiBox-root {
      border-bottom-right-radius: 0;
    }
  }
`;

export const box = css`
  width: 288px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05), 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  padding: ${spacing(2.5)}px;
`;

export const titleText = css`
  position: relative;
  margin-bottom: ${spacing(1)}px;
  font-weight: bold;
`;

export const contentText = css`
  line-height: normal;
  color: ${greyDark};
`;

export const contentTextWithBtn = css`
  margin-bottom: ${spacing(2.5)}px;
`;

export const button = css`
  width: 46.2%;
  margin-right: ${theme.spacing(1.5)}px;
`;
